// extracted by mini-css-extract-plugin
module.exports = {"base":"SearchPopover_base__3PT5t","open":"SearchPopover_open__2foNe"};